import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { TokenManager } from '@core-managers/token.manager';
import { DomainContactInfo, IContact } from '@core-models/contacts.model';
import { UrlQueryDef } from '@shared-base/url-query-definition.base';
import { TranslateService } from '@shared-services/translate.service';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { HttpHeadersConst } from '@core-constants/http-headers.const';
import { EntityDataServiceWithProcessingBase } from '@shared-base/entity-data-service-processing.base';

@Injectable({ providedIn: 'root' })
export class ContactsDataService extends EntityDataServiceWithProcessingBase
{
  constructor(@Inject(PLATFORM_ID) protected platformId,
    protected http: HttpClient,
    protected tokenManager: TokenManager,
    protected translateService: TranslateService)
  {
    super(platformId, http, 'contacts');
  }

  public getList(): Observable<any>
  {
    const queryDef = new UrlQueryDef();
    queryDef.addHeader(HttpHeadersConst.AcceptLanguage, this.translateService.languageCode);

    const user = this.tokenManager.getUser();

    const observable = this.http.get(this.createMicroserviceURL('list', user.id), queryDef.getRequestConfig()).pipe(share());

    this._loadingMaskHandleObservableResponse(observable);

    return observable;
  }

  public update(contact: IContact): Observable<any>
  {
    const queryDef = new UrlQueryDef();
    queryDef.addHeader(HttpHeadersConst.AcceptLanguage, this.translateService.languageCode);

    const observable = this.http.put(this.createMicroserviceURL(), contact, queryDef.getRequestConfig()).pipe(share());

    this._loadingMaskHandleObservableResponse(observable);

    return observable;
  }

  public create(contact: IContact): Observable<any>
  {
    const queryDef = new UrlQueryDef();
    queryDef.addHeader(HttpHeadersConst.AcceptLanguage, this.translateService.languageCode);

    const observable = this.http.post(this.createMicroserviceURL(), contact, queryDef.getRequestConfig()).pipe(share());

    this._loadingMaskHandleObservableResponse(observable);

    return observable;
  }

  public removeRedisContactDomain(): Observable<any>
  {
    const queryDef = new UrlQueryDef();

    const token = this.tokenManager.getToken();

    const dto = {
      cartId: this.tokenManager.getCartCookie()
    };

    const observable = this.http.post(this.createMicroserviceURL("remove/domain-contacts"), { body: dto, headers: queryDef.getRequestConfigWithAuthorizationToken(token, this.translateService.languageCode) }).pipe(share());

    return observable;

  }

  public addRedisContactDomain(contact: DomainContactInfo): Observable<any>
  {
    const queryDef = new UrlQueryDef();
    queryDef.addHeader(HttpHeadersConst.AcceptLanguage, this.translateService.languageCode);

    contact.token = this.tokenManager.getToken();
    contact.cartId = this.tokenManager.getCartCookie();

    const observable = this.http.post(this.createMicroserviceURL('domain-contacts-order'), contact, queryDef.getRequestConfig()).pipe(share());

    this._handleObservableResponse(observable);

    return observable;

  }

  public getRedisContactDomain(): Observable<any>
  {
    const queryDef = new UrlQueryDef();
    queryDef.addHeader(HttpHeadersConst.AcceptLanguage, this.translateService.languageCode);

    queryDef.addParam("cartId", this.tokenManager.getCartCookie());

    const observable = this.http.get(this.createMicroserviceURL('domain-contacts-order'), queryDef.getRequestConfig()).pipe(share());

    this._handleObservableResponse(observable);

    return observable;
  }
}

